import React from "react";
import { LinkDto } from "../../../Api/Model/LinkDto.csharp";

interface NavigationLinkProps {
  link: LinkDto;
  onClick?: () => void;
  className?: string
}

export const NavigationLink: React.FC<NavigationLinkProps> = ({
  link: { url, title },
  onClick,
  className
}) => {
  return (
    <>
      {url && <a className={className} href={url}>{title}</a>}
      {!url && onClick && <button className={className} onClick={onClick}>{title}</button>}
      {!url && !onClick && <span className={className}>{title}</span>}
    </>
  );
};
